import React, {useState} from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import './style.css'
import NavJudul from 'components/componentsmall/nav_judul'
import {Link} from 'react-router-dom'

export default function Navbars() {
    const [actived, setActived] = useState(false)

    const navBackground = _ => {
        if(window.scrollY >= 80) {
            setActived(true)
        } else {
            setActived(false)
        }
    }

    window.addEventListener('scroll', navBackground)
    return (
        <div className="home">
        <Navbar className={actived ? "navbar-active" : "navbar"} collapseOnSelect expand="lg" fixed="top">
            <Container className="container-navbar">
                <NavJudul />
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                    <Navbar.Collapse id="responsive-navbar-nav">
                        <Nav className="ml-auto">
                            <Nav.Link><Link to="/about">Tentang Kami</Link></Nav.Link>
                            <Nav.Link><Link to="/produck">Galeri Produk</Link></Nav.Link>
                            <Nav.Link>
                                <Link to="/login"><button className="masuk" type="button">Masuk</button></Link>
                            </Nav.Link>
                            <Nav.Link>
                                <Link to="/daftar"><button className="daftar" type="button">Daftar</button></Link>
                            </Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
            </Container>
        </Navbar>
        </div>         
    )
}
